<microempresario-header></microempresario-header>
<div class="body">
  <div class="container">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Deshabilitar <span class="txtbienvenida-2">usuario</span></h3>
      </div>
    </div>
    <form class="custom-form" [formGroup]="eliminarCuentaForm">
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xs-8">
          <div class="mb-3 required form-label" [ngClass]="{'is-invalid':validateField('contraActual')}">
            <label for="contrasenia" class="form-label">Contraseña actual</label>
            <div class="input-group">
              <input maxlength="20" [type]="isVisible ? 'text' : 'password'" class="form-control" formControlName="contraActual" [ngClass]="{'is-invalid':validateField('contraActual')}" required />
              <span class="input-group-text" (click)="showPassword()">
                <span [class]="isVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </span>
              <div class="invalid-feedback">
                Campo obligatorio (Debe tener como mínimo 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 caracter especial (&#64;$+#!%*?&-/_.,))
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mt-4">
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xs-8">
          <div class="mb-3 required form-label" [ngClass]="{'is-invalid':validateField('observaciones')}">
            <label for="observaciones" class="form-label">Observaciones</label>
            <textarea name="observaciones" formControlName="observaciones" maxlength="500" style="width: 100%;" rows="3" class="form-control"
            [ngClass]="{'is-invalid':validateField('observaciones')}" required></textarea>
            <div class="invalid-feedback">
              Campo obligatorio. Mínimo 50 caracteres.
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center mt-4 g-2">
        <div class="col-12 col-md-2 container-btn">
          <button  class="btn btn-primary hvr-shrink" (click)="validateForm()" style="width: 180px;" type="submit">
            @if (isLoading) {
              <div class="spinner-grow text-light" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            }
            {{ isLoading ? "" : "Deshabilitar" }}
          </button>
        </div>
        <div class="col-12 col-md-2 container-btn">
          <button class="btn  btn-primary hvr-shrink" style="width: 180px;" routerLink="/microempresario/home">Volver</button>
        </div>
      </div>
    </form>
  </div>
  <div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
